export const reviews = [
  // Hair Removal Products
  {
    id: 1,
    customerName: "Dr Priya",
    product: "DIODE HAIR REMOVAL",
    category: "Hair",
    rating: 5,
    review: "The DIODE HAIR REMOVAL system has transformed our clinic's hair removal services. The advanced diode + picosecond technology works on all skin types beautifully. Clients report minimal discomfort and excellent results after 4-6 sessions."
  },
  {
    id: 2,
    customerName: "Dr Rajesh",
    product: "GENELUX-3",
    category: "Hair",
    rating: 5,
    review: "GENELUX-3 is a game-changer for hair removal treatments. The quad wavelength technology works perfectly on all skin types and hair colors. Patient satisfaction has increased significantly and our repeat booking rate is at 90%."
  },
  {
    id: 3,
    customerName: "Dr Meera",
    product: "DIODE HAIR REMOVAL",
    category: "Hair",
    rating: 5,
    review: "This diode laser system is incredibly efficient and reliable. The combination of laser and picosecond technology provides comprehensive treatment options. Results are permanent and clients love the fast treatment sessions."
  },
  {
    id: 4,
    customerName: "Dr Deepa",
    product: "GENELUX-3",
    category: "Hair",
    rating: 5,
    review: "The multiple wavelengths make GENELUX-3 perfect for all skin tones and hair types. Fast treatments, comfortable for patients, and long-lasting results. Clients keep coming back for maintenance sessions."
  },
  {
    id: 5,
    customerName: "Dr Aishwarya",
    product: "DIODE HAIR REMOVAL",
    category: "Hair",
    rating: 5,
    review: "Excellent machine for permanent hair reduction on all body areas. Works beautifully on facial hair, underarms, and legs. Clients are thrilled with the painless treatment and visible results after just 3 sessions."
  },

  // Skin Care Products
  {
    id: 6,
    customerName: "Dr Vikram",
    product: "ULTRA Q",
    category: "Skin",
    rating: 5,
    review: "The ULTRA Q has transformed our clinic's skin treatment capabilities. Outstanding results on pigmentation, melasma, and age spots. Clients see dramatic improvements and we've had repeat treatments exceed 85%."
  },
  {
    id: 7,
    customerName: "Dr Anjali",
    product: "ULTRAFRAX CO2",
    category: "Skin",
    rating: 5,
    review: "Exceptional results on acne scars and skin resurfacing. The fractional CO2 laser is precise, powerful, and effective. Patients see visible improvements after just 2-3 sessions with amazing skin texture transformation."
  },
  {
    id: 8,
    customerName: "Dr Sanjay",
    product: "HYDRA FACIAL",
    category: "Skin",
    rating: 5,
    review: "The multi-functional capabilities of our hydrafacial machine are impressive. Deep cleansing, exfoliation, hydration, and LED therapy all in one device. Clients love the immediate glow and book weekly sessions."
  },
  {
    id: 9,
    customerName: "Dr Kavita",
    product: "ULTRA Q",
    category: "Skin",
    rating: 5,
    review: "Amazing machine for pigmentation and tattoo removal treatment! The wavelengths work wonders on stubborn pigmentation. Minimal downtime for patients and remarkable results. Training support was excellent."
  },
  {
    id: 10,
    customerName: "Dr Suresh",
    product: "ULTRAFRAX CO2",
    category: "Skin",
    rating: 5,
    review: "Best CO2 laser for skin resurfacing we've used. Treats everything from acne scars to wrinkles and age spots effectively. The precision and control are excellent, and patients see results within days."
  },
  {
    id: 11,
    customerName: "Dr Pooja",
    product: "HYDRA FACIAL",
    category: "Skin",
    rating: 5,
    review: "This hydrafacial system is a must-have for any aesthetic clinic. Clients see instant results in skin brightness and hydration. The versatile functions make it perfect for all skin types and concerns."
  },
  {
    id: 12,
    customerName: "Dr Anil",
    product: "ULTRA Q",
    category: "Skin",
    rating: 5,
    review: "Outstanding results for pigmentation removal and skin rejuvenation. Clients see significant lightening of dark spots after 3-4 sessions. The machine is reliable, durable, and offers great ROI."
  },

  // Microneedling Products
  {
    id: 13,
    customerName: "Dr Neha",
    product: "MICRONEEDLE RF",
    category: "Micro",
    rating: 5,
    review: "Our RF microneedling device has revolutionized our collagen induction treatments. Results for fine lines, wrinkles, and skin texture are outstanding. Clients notice improvements after the first session!"
  },
  {
    id: 14,
    customerName: "Dr Ravi",
    product: "MICRONEEDLE RF",
    category: "Micro",
    rating: 5,
    review: "The combination of microneedling and radiofrequency energy is powerful. Treats acne scars, stretch marks, and aging skin beautifully. Downtime is minimal and results keep improving for weeks after treatment."
  },
  {
    id: 15,
    customerName: "Dr Sneha",
    product: "MICRONEEDLE RF",
    category: "Micro",
    rating: 5,
    review: "RF microneedling has become our highest-grossing treatment. The stimulation of collagen production creates natural-looking results. Clients love the minimal downtime and visible tightening effects."
  },
  {
    id: 16,
    customerName: "Dr Arjun",
    product: "MICRONEEDLE RF",
    category: "Micro",
    rating: 5,
    review: "Exceptional results for treating acne scars and improving skin texture. The radiofrequency energy combined with microneedling creates an excellent healing response. Clients are incredibly satisfied."
  },

  // Machine Products
  {
    id: 17,
    customerName: "Dr Anjali",
    product: "MEDI LIFT HIFU",
    category: "Machines",
    rating: 5,
    review: "The HIFU machine delivers incredible non-surgical facelift results. Clients love the natural-looking lifting and tightening effect. The technology is advanced yet intuitive to operate. ROI exceeded expectations!"
  },
  {
    id: 18,
    customerName: "Dr Kartik",
    product: "MEDI LIFT HIFU",
    category: "Machines",
    rating: 5,
    review: "Outstanding results for facial lifting and neck skin tightening. No surgery, no downtime, and clients see visible improvements immediately. This has become our most popular and profitable treatment."
  },
  {
    id: 19,
    customerName: "Dr Divya",
    product: "MEDI LIFT HIFU",
    category: "Machines",
    rating: 5,
    review: "HIFU treatments are now 40% of our monthly revenue! Results for jawline definition and overall facial lifting are remarkable. Clients book multiple sessions as results continue to improve."
  },
  {
    id: 20,
    customerName: "Dr Varun",
    product: "MEDI LIFT HIFU",
    category: "Machines",
    rating: 5,
    review: "The precision and energy delivery of HIFU technology is impressive. Works great on all skin types and ages. The non-invasive nature appeals to our clients who want natural-looking results without surgery."
  },
  {
    id: 21,
    customerName: "Dr Manisha",
    product: "LASER VASCULAR",
    category: "Machines",
    rating: 5,
    review: "Our vascular laser has been excellent for treating rosacea, spider veins, and red spots. Results are visible immediately and clients need minimal touch-ups. The machine is reliable and easy to use."
  },
  {
    id: 22,
    customerName: "Dr Harsha",
    product: "LASER VASCULAR",
    category: "Machines",
    rating: 5,
    review: "Vascular lesions and rosacea treatment has never been easier. The precision targeting reduces surrounding tissue damage. Clients love the quick sessions and visible improvement in skin tone."
  }
  ,
  // Additional diverse reviews
  {
    id: 23,
    customerName: "Dr Ritika",
    product: "LED THERAPY PANEL",
    category: "Skin",
    rating: 5,
    review: "Our LED panel has improved post-procedure healing and boosted client satisfaction. Great for acne and skin rejuvenation, very gentle and effective when combined with facials."
  },
  {
    id: 24,
    customerName: "Dr Kunal",
    product: "SCALP MICRONEEDLING",
    category: "Hair",
    rating: 5,
    review: "Scalp microneedling with topical growth serums has noticeably improved hair density in our patients. A valuable add-on to our hair restoration packages."
  },
  {
    id: 25,
    customerName: "Dr Mehul",
    product: "PRP KIT",
    category: "Micro",
    rating: 5,
    review: "The PRP kit is user-friendly and delivers consistent platelet concentration. Excellent results for hair regrowth and scar remodeling when paired with microneedling."
  },
  {
    id: 26,
    customerName: "Dr Sonal",
    product: "CRYO SLIM",
    category: "Machines",
    rating: 5,
    review: "Cryo Slim sessions are a hit with our clients seeking non-invasive body contouring. Noticeable fat reduction with minimal downtime and high repeat booking rates."
  },
  {
    id: 27,
    customerName: "Dr Isha",
    product: "BRIGHTENING SERUM",
    category: "Skin",
    rating: 5,
    review: "The professional brightening serum we retail has become a top-seller. Clients see improved glow and texture when used post-laser treatments."
  },
  {
    id: 28,
    customerName: "Dr Rohit",
    product: "FRACTIONAL NEEDLE",
    category: "Micro",
    rating: 5,
    review: "The fractional microneedle tips are durable and provide reliable results for collagen induction. Great for stretch marks and deep acne scars."
  }
];
